export default __webpack_public_path__ + "static/media/eco-score-A.2337a9f0.svg";